<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-25 15:09:42
 * @FilePath: \gcp-fe\src\app\shop\components\showUser.vue
 * @Description: 
-->
<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-25 15:05:09
 * @FilePath: \gcp-fe\src\app\shop\components\showUser.vue
 * @Description: 登录用户信息
-->
<template>
  <div class="show-user fl">
    <div class="user ccui-clearfix">
      <img :src="headLogo" class="user-head mr15" />
      <div>
        <template v-if="loginInfo.name">
          <div class="user-type-welcome">
            {{ $t("showUser.title") }}，{{ loginInfo.name }}
          </div>
          <!-- <el-link type="primary" @click="handleExit"
            >退出<i class="icon-ccui-next"></i
          ></el-link> -->
          <div
            class="user-type-welcome welcomeBox"
            :title="$t('showUser.welcomeTitle')"
          >
            {{ $t("showUser.welcomeTitle") }}
          </div>
          <!-- 供应商登录才展示 start -->
          <div
            v-if="
              reviewStateInfo &&
                reviewStateInfo.isYgyReview == 1 &&
                reviewStateInfo.isHkMacauOverseas == 0 &&
                supCode &&
                supCode != undefined
            "
          >
            <div
              v-if="
                $route.query.supCode &&
                  reviewStateInfo.auditStatus &&
                  reviewStateInfo.auditStatus != 0 &&
                  reviewStateInfo.auditStatus != 2 &&
                  reviewStateInfo.auditStatus != 3
              "
              class="riskStatus"
              :style="setBackground"
            >
              <div
                v-if="
                  reviewStateInfo.auditStatus != 21 &&
                    reviewStateInfo.auditStatus != 23 &&
                    reviewStateInfo.auditStatus != 24
                "
                class="riskStatusLeft"
                :style="setColor"
              >
                {{ reviewStateInfo.reviewStateName }}
              </div>
              <div
                v-if="
                  reviewStateInfo.auditStatus != 21 &&
                    reviewStateInfo.auditStatus != 23 &&
                    reviewStateInfo.auditStatus != 24
                "
                class="riskStatusRight"
                @click="handleEvaluate"
              >
                查看评估 >
              </div>
              <div
                v-if="
                  reviewStateInfo.auditStatus == 21 ||
                    reviewStateInfo.auditStatus == 23 ||
                    reviewStateInfo.auditStatus == 24
                "
                style="width: 100%; 
                text-align: center;"
              >
                <div :style="setColor">
                  {{ reviewStateInfo.reviewStateName }}
                </div>
              </div>
            </div>
            <div
              v-else-if="
                !$route.query.supCode &&
                  reviewStateInfo.auditStatus &&
                  reviewStateInfo.auditStatus != 0 &&
                  reviewStateInfo.auditStatus != 2 &&
                  reviewStateInfo.auditStatus != 3 &&
                  reviewStateInfo.auditStatus != 23 &&
                  reviewStateInfo.auditStatus != 24
              "
              class="riskStatus"
              :style="setBackground"
            >
              <div
                v-if="
                  reviewStateInfo.auditStatus != 21 &&
                    reviewStateInfo.auditStatus != 23 &&
                    reviewStateInfo.auditStatus != 24
                "
                class="riskStatusLeft"
                :style="setColor"
              >
                {{ reviewStateInfo.reviewStateName }}
              </div>
              <div
                v-if="
                  reviewStateInfo.auditStatus != 21 &&
                    reviewStateInfo.auditStatus != 23 &&
                    reviewStateInfo.auditStatus != 24
                "
                class="riskStatusRight"
                @click="handleEvaluate"
              >
                查看评估 >
              </div>
              <div
                v-if="
                  reviewStateInfo.auditStatus == 21 ||
                    reviewStateInfo.auditStatus == 23 ||
                    reviewStateInfo.auditStatus == 24
                "
                style="width: 100%; 
                text-align: center;"
              >
                <div :style="setColor">
                  {{ reviewStateInfo.reviewStateName }}
                </div>
              </div>
            </div>
          </div>
          <!-- 供应商登录才展示 end -->
          <button class="btn3" @click="handleExit">
            {{ $t("showUser.logout") }}
          </button>
        </template>
        <template v-else>
          <div
            class="user-type-welcome"
            style="padding: 6px 0 0px 10px; margin-bottom: 6px"
          >
            {{ $t("showUser.title") }}！
          </div>
          <div
            class="user-type-welcome welcomeBox"
            :title="$t('showUser.welcomeTitle')"
            style="margin-bottom: 14px"
          >
            {{ $t("showUser.welcomeTitle") }}
          </div>
          <div class="btnBox">
            <button class="btn1" @click="handleLogin">
              {{ $t("showUser.login") }}
            </button>
            <button class="btn2" @click="handleRegister">
              {{ $t("showUser.register") }}
            </button>
          </div>
          <div class="btnBoxs">
            <span
              class="btn"
              :title="$t('showUser.findPassword')"
              @click="ZHMM(1)"
              >{{ $t("showUser.findPassword") }}</span
            >
            <span class="tup"></span>
            <span
              class="btn"
              :title="$t('showUser.findPasswordSub')"
              @click="ZHMM(2)"
              >{{ $t("showUser.findPasswordSub") }}</span
            >
          </div>
          <div class="btnBoxs1">
            <!-- <span class="btn" @click="ZHMM(3)"
              >管控名单及黑名单重新认定申请及申诉</span
            > -->
            <span
              class="btn"
              :title="$t('showUser.controlListOrBlackAppeal')"
              @click="ZHMM(3)"
              >{{ $t("showUser.controlListOrBlackAppeal") }}</span
            >
          </div>
        </template>
      </div>
    </div>
    <!-- <div class="userimg ccui-clearfix">
      <div class="announcements-box">
        <div class="announcements-title ccui-clearfix">
          <i class="icon-ccui-trumpet" style="float:left;margin-top:5px"></i>
          <span class="fl">通知公告</span>
          <el-link
            :underline="false"
            type="info"
            class="fr color-1"
            @click="handleViewAll()"
            >更多 ></el-link
          >
        </div>
        <ul class="announcements-ul">
          <template v-for="item in pageData">
            <li :key="item.id" class="ellipsis announcements-ul-li">
              <a @click="handleOp(item)" class="ellipsis" :title="item.title">
                【公告】{{ item.title }}</a
              >
            </li>
          </template>
        </ul>
      </div>
    </div> -->
    <evaluateDialog ref="evaluateDialog" />
  </div>
</template>

<script>
// import { queryPublishedNoticeList } from "@/app/shop/api/shopping";
import Cookies from "js-cookie";
import { addUrlPerFix } from "@/basa/utils";
import {
  OAuth,
  // queryLscpPortalList,
  getBusiTravelUrl,
  // queryPublishedNoticeList,
  qryNoticeInfoPageList
} from "@/app/shop/api/shopping";

import { qrySupYgyReviewState } from "@/app/valuationFeedback/api";

// import moment from "moment";
import { COMM_TYPE_MAPPING } from "@/config/const/comm";
import { updateNoticeHits } from "../api/shopping";
import evaluateDialog from "@/app/valuationFeedback/views/evaluateDialog.vue";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  components: { evaluateDialog },
  data() {
    return {
      dividerList: [],
      baseUrl: addUrlPerFix(process.env.VUE_APP_BASE_URL),
      purchaseAgentId: "",
      supplyAgentId: "",
      imgOptionsA: [],
      imgOptionsB: [],
      pageData: [],
      supCode: Cookies.get("sup_code") || this.$route.query.supCode,
      reviewStateInfo: {} //查询供应商注册一公院审查状态
    };
  },
  mounted() {},
  activated() {
    this.init();
  },
  deactivated() {
    this.dividerList = [];
  },
  methods: {
    ZHMM(type) {
      // 分包商找回密码
      if (type === 1) {
        // 供应商
        this.$router.push({
          path: "/findPassword"
        });
      } else if (type === 2) {
        // 分包商
        this.$router.push({
          path: "/subFindPassword"
        });
      } else if (type === 3) {
        // 管控名单或黑名单申诉
        this.$router.push({
          path: "/subAppeal"
        });
      }
    },
    init() {
      // // 查询中交商旅
      // queryLscpPortalList({
      //   columnType: 4,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.imgOptionsA = res.data.data;
      //     // this.imgOptionsB =
      //     //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
      //   }
      // });
      // // 查询中交福利
      // queryLscpPortalList({
      //   columnType: 5,
      //   isShowPageLoading: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.imgOptionsB = res.data.data;
      //     // this.imgOptionsB =
      //     //   res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
      //   }
      // });
      // queryPublishedNoticeList({
      //   pageNo: 1,
      //   pageSize: 6,
      //   module: 1,
      //   pageState: 2,
      //   textType: 1,
      //   appId: 100123
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     // this.pageData = res.data.data.rows.filter(item => {
      //     //   return item.textType == 1;
      //     // });
      //     this.pageData = res.data.data.rows;
      //   }
      // });
      // 查询通知公告信息
      this.getNoticeInfoPageList();
      if (this.supCode) {
        let obj = {
          supCode: this.supCode
        };
        qrySupYgyReviewState(obj).then(res => {
          if (res.data.code == "0") {
            this.reviewStateInfo = res.data.data;
          }
        });
      }
    },
    // 更多
    handleViewAll() {
      this.$router.push({
        path: "/noticeList"
      });
    },
    handleOp(row) {
      //通知公告  https://test01-sp.iccec.cn/announcementDetail?id=94
      // let routeUrl = this.$router.resolve({
      //   path: "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId
      //   }
      // });
      // window.open(routeUrl, "_blank");
      // window.location.href = `${this.$addUrlPerFix(
      //   process.env.VUE_APP_SP_URL
      // )}/announcementDetail?id=${row.noticeInfoId}&isJRZL=1&searchType=首页`;
      updateNoticeHits({ noticeId: row.id });
      this.$router.push({
        path: "/noticeDetail",
        query: {
          id: row.id
        }
      });
    },
    handleHelp(index, targetUrl) {
      // 中交商旅
      if (index === 1) {
        if (
          Cookies.get("access_token") &&
          JSON.parse(localStorage.getItem("userInfo"))?.openId
        ) {
          getBusiTravelUrl({
            empOpenId: JSON.parse(localStorage.getItem("userInfo")).openId
          }).then(res => {
            if (res.data.code == "0") {
              if (res.data.data.body) {
                window.location.href = res.data.data.body;
              }
            } else if (res.data.code == "111") {
              window.location.href = targetUrl;
            }
          });
        } else {
          window.location.href = targetUrl;
        }
        // window.open("https://newtravel.iccec.cn/userVue", "_blank");
        // if (Cookies.get("access_token")) {
        //   this.supplyAgentId = JSON.parse(
        //     localStorage.getItem("agentIdList")
        //   ).supplyAgentId;
        //   let href = "";
        //   if (this.baseUrl.indexOf("dev01") != -1) {
        //     href = `https://dev01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else if (this.baseUrl.indexOf("test01") != -1) {
        //     href = `https://test01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else if (this.baseUrl.indexOf("uat01") != -1) {
        //     href = `https://uat01-smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   } else {
        //     href = `https://smp.iccec.cn/contractManagement/materialContractDraft/item-list?a=${this.supplyAgentId}`;
        //   }
        //   window.open(href, "_blank");
        // } else {
        //   window.location.href =
        //     this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        //     "?redirectUrl=" +
        //     this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        // }
      }
      // 中交福利
      if (index === 2) {
        // window.open("https://new-welfare-h5.iccec.cn/", "_blank");
        let oma_remote_url = targetUrl + "@corpid@10000";
        OAuth({
          isShowLoading: true,
          // oma_remote_url: "https://aimarket.iccec.cn/front/login@corpid@10000"
          oma_remote_url: oma_remote_url
        }).then(res => {
          if (res.data.code == 111) {
            // let tagerUrl = "https://new-welfare-h5.iccec.cn/";
            // if (window.location.host.indexOf("test01") != -1) {
            //   tagerUrl = "http://dev.welfare.h5.aihl.ren/";
            // }
            window.location.href = targetUrl;
            return;
          }
          if (res.data.data) {
            window.location.href = res.data.data;
          }
        });
        // .catch(res => {
        //   if (res.data.code == 111) {
        //     this.$message({
        //       showClose: true,
        //       message: "请先登录！",
        //       duration: 3000,
        //       type: "error",
        //       ccuiCustom: true
        //     });
        //   }
        // });
      }
    },
    //退出
    handleExit() {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(window.location.href);
    },
    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    // 新用户注册
    handleRegister() {
      // 跳转注册页面
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_SRA_URL
      )}/index`;
    },
    async getNoticeInfoPageList() {
      const res = await qryNoticeInfoPageList({
        pageNum: 1,
        pageSize: 6,
        status: 2,
        type: COMM_TYPE_MAPPING.INDEX_NOTICES,
        languageFlag: Cookies.get("language")
      });
      this.pageData = res.data.data.rows;
    },
    // 查看评估
    handleEvaluate() {
      this.$refs["evaluateDialog"].dialogVisible = true;
    }
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/logOn.png");
      }
    },
    setBackground() {
      let bagkColor = "";
      switch (this.reviewStateInfo?.auditResult) {
        case "22":
          bagkColor = "#FBF4F3";
          break;
        case "23":
          bagkColor = "#D3F2F7";
          break;
        case "24":
          bagkColor = "#C7F2E8";
          break;
        case "25":
          bagkColor = "#FBEDE0";
          break;
        default:
          bagkColor = "#f2f7fc";
          break;
      }
      return `background: ${bagkColor}`;
    },
    setColor() {
      let color = "";
      switch (this.reviewStateInfo?.auditResult) {
        case "22":
          color = "#DE1718";
          break;
        case "23":
          color = "#379DB5";
          break;
        case "24":
          color = "#3A9A59";
          break;
        case "25":
          color = "#C76F15";
          break;
        default:
          color = "#0089EF";
          break;
      }
      return `color: ${color}`;
    }
  }
};
</script>

<style scoped lang="scss">
.clearfix-item {
  display: flex;
  background: #ffffff;
}

.show-user {
  width: 260px;
  height: 240px;

  .user {
    width: 260px;
    height: 240px;
    margin-bottom: 10px;
    background: #ffffff;

    .user-head {
      width: 52px;
      height: 52px;
      display: block;
      margin: auto;
      padding: 18px 103px 5px 103px;
    }

    .user-type-welcome {
      // height: 28px;
      // font-family: PingFang-SC-Medium;
      // font-size: 20px;
      // color: #4a4a4a;
      // letter-spacing: 0;
      // font-weight: 500;
      width: 200px;
      height: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
      line-height: 18px;
      text-align: center;
      margin: auto;
      font-style: normal;
      margin-bottom: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .riskStatus {
      margin: 5px auto 10px;
      width: 200px;
      height: 24px;
      align-items: center;
      border-radius: 4px;
      display: flex;
      .riskStatusLeft {
        width: 118px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-right: 1px dashed #cba8a8;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #de1718;
      }
      .riskStatusRight {
        width: 81px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #2697ff;
        cursor: pointer;
      }
    }

    .welcomeBox {
      width: 100%;
      max-width: 240px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #666666;
      padding: 6px 0 0px 0;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .btnBox {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btnBoxs1 {
      width: 100%;
      display: flex;
      font-size: 13px;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 4px;
      .btn {
        cursor: pointer;
        color: #999999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 240px;
        text-align: center;
      }
      .btn:hover {
        color: #0089ef;
        text-decoration: underline;
      }
    }
    .btnBoxs {
      width: 100%;
      display: flex;
      font-size: 13px;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      box-sizing: border-box;
      margin-top: 10px;
      position: relative;
      .tup {
        position: absolute;
        height: 13px;
        width: 0;
        left: 49%;
        top: 5px;
        transform: translateX(-50%);
        border-right: 2px solid #999999;
      }
      .btn {
        cursor: pointer;
        color: #999999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        text-align: center;
        min-width: 0;
      }
      .btn:hover {
        color: #0089ef;
        text-decoration: underline;
      }
    }

    .btn1 {
      cursor: pointer;
      // margin-left: 16px;
      margin-right: 16px;
      min-width: 70px;
      height: 32px;
      border-radius: 4px;
      background: #ffffff;
      color: #0089ef;
      border: 1px solid #0089ef;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      padding: 0 12px;
      white-space: nowrap;
    }

    .btn2 {
      cursor: pointer;
      min-width: 70px;
      height: 32px;
      background: #0089ef;
      border-radius: 4px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      border: 1px solid #0089ef;
      color: #ffffff;
      padding: 0 12px;
      white-space: nowrap;
    }

    .btn3 {
      min-width: 109px;
      height: 32px;
      border: 1px solid #0089ef;
      border-radius: 4px;
      margin-left: 78px;
      background: #ffffff;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #0089ef;
      padding: 0 12px;
      white-space: nowrap;
    }

    .user-type-link {
      height: 18px;
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
    }
  }

  .userimg {
    width: 260px;
    height: 200px;
    background: #ffffff;

    .userimg-item {
      margin: 10px;
    }
  }
}

.divider-header {
  padding: 10px 0 16px 0;
  font-size: 12px;
  line-height: 18px;

  .titleIcon {
    display: inline-block;

    .icon-ccui-bell-o {
      margin-right: 5px;
      color: #ff954e;
    }

    .icon-ccui-bell-o + span {
      color: #4a4a4a;
    }
  }

  .titleIcon + a {
    color: #9b9b9b;
  }
}

.dividerList {
  width: 240px;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
  font-weight: 400;

  li {
    line-height: 18px;
    font-weight: 400;
    margin-bottom: 4px;
  }
}

.fl {
  float: left;
}

.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}

.help-center-img {
  margin: 0 8px 10px;
}

/deep/.announcements-box {
  margin: 5px 10px 0;
  font-size: 13px;
  line-height: 22px;

  .announcements-title {
    margin-bottom: 7px;

    .fl {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #4a4a4a;
    }

    .fr {
      line-height: 18px;
      font-size: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #999999;

      &:hover {
        color: #0089ef;
      }
    }
  }

  .announcements-ul {
    padding: 3px 0 18px;

    .announcements-ul-li {
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: 400;
      margin-bottom: 8px;
      font-family: PingFangSC, PingFang SC;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
